import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import classnames from 'classnames/bind';
import qs from 'query-string';

import { generateModulePath } from '@autopass-web/domain';

import { analytics } from '../../app-loader';
import useAppStore from '../../app-store';
import { PromotionItems } from '../../component/item';
import { PromotionLoading } from '../../component/loading';
import { PromotionCarousel } from '../../component/promotion-carousel';
import { PROMOTION_LIST } from '../../config';
import usePromotionStore from '../../promotion-store';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Promotion = ({ locationSearch }) => {
  const store = usePromotionStore();
  const appStore = useAppStore();
  const navigate = useNavigate();
  const location = useLocation();

  const search = qs.parse(location.search);

  const { filterBy } = search || {};
  const generatePath = generateModulePath(
    appStore.nextModule,
    appStore.basePath,
  );

  const promotionTypes = Array.from(
    store.rawData.reduce((set, { displayPromotionTypes }) => {
      for (const promotionType of displayPromotionTypes) {
        set.add(promotionType);
      }

      return set;
    }, new Set()),
  ).filter((type) => type in PROMOTION_LIST);

  useEffect(() => {
    analytics.promotion_pageView();
    let [typeKey] =
      Object.entries(PROMOTION_LIST).find((x) => x[1].id === filterBy) || [];

    let newFilterBy = (() => {
      if (appStore.app) {
        return typeKey ?? appStore.distributor.promotionSupportList?.[0];
      }
      return promotionTypes[0];
    })();

    if (appStore.app === 'guest-aps') {
      // 但這裡怪怪的，fetchApsPromotions 這個裡面有點問題，每次都不一樣
      store.setFilterBy(newFilterBy);
      store.fetchApsPromotions();
    } else {
      !store.filterBy && store.setFilterBy(newFilterBy);
      store.fetchPromotions();
    }
    // only first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!store.filterBy && promotionTypes.length > 0) {
    store.setFilterBy(promotionTypes[0]);
    store.fetchPromotions();
  }

  const promotions = store.rawData.filter(({ displayPromotionTypes }) => {
    return displayPromotionTypes.includes(store.filterBy);
  });

  if (appStore.app === 'guest-aps') {
    return (
      <div className={styles.promotion}>
        <PromotionItems
          promotions={promotions}
          loading={store.loading}
          filterBy={store.filterBy}
        />
      </div>
    );
  }

  const Tabs = () => {
    return promotionTypes
      ?.toSorted((typeA, typeB) => {
        const orderA = PROMOTION_LIST[typeA].order;
        const orderB = PROMOTION_LIST[typeB].order;

        return orderA - orderB;
      })
      .map((type) => {
        let typeInfo = PROMOTION_LIST[type];

        const tabClass = cx({
          tab: true,
          active: type === store.filterBy,
        });

        return (
          <div
            className={tabClass}
            onClick={() => {
              analytics.promotion_tab_onClick({
                name: PROMOTION_LIST[typeInfo.key].analyticsName,
              });
              if (!appStore.app) {
                navigate(generatePath(`?filterBy=${typeInfo.id}`), {
                  replace: true,
                });
              }
              store.setFilterBy(type);
            }}
            key={typeInfo.id}
          >
            {typeInfo.name}
          </div>
        );
      });
  };

  return (
    <div className={styles.promotion}>
      <PromotionCarousel promotions={store.promotionCollections ?? []} />
      <div className={styles['tabs-container']}>
        <Tabs />
      </div>
      {store.loading ? (
        <>
          <PromotionLoading />
          <PromotionLoading />
          <PromotionLoading />
          <PromotionLoading />
        </>
      ) : promotions.length === 0 ? (
        <div className={styles['empty-view']}>
          優惠即將上線
          <br />
          麻吉們再稍等一下
        </div>
      ) : (
        <PromotionItems
          promotions={promotions}
          loading={store.loading}
          filterBy={store.filterBy}
        />
      )}
    </div>
  );
};

export default Promotion;
